import LoadingButton from "@mui/lab/LoadingButton";
import { Button } from "@mui/material";
import { useState } from "react";
import Swal from "sweetalert2";
import api from "../../../../../Apis";
import { useTranslation } from "react-i18next"
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

export default function ButtonDeleteAllFanpage(props) {
    const { t, i18n } = useTranslation();
    const [state, setState] = useState({
        loading: false
    })
    const { cookies } = props;
    const removeAllFanpage = () => {
        Swal.fire({
            title: t("dashboard.titleDeleteAllFanpage"),
            text: '',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t('common.alert.confirm'),
            cancelButtonText: t('common.alert.cancel')
        }).then((result) => {
            if (result.isConfirmed) {
                setState({
                    ...state,
                    loading: true
                })
                const requestOptions = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + cookies.is_login
                    },
                    body: JSON.stringify({
                        lang: i18n.language
                    })
                };
                fetch(api.delete_all_fanpage, requestOptions)
                .then(res => res.json())
                .then(
                    (result) => {
                        if (result.success) {
                            setState({
                                ...state,
                                loading: false
                            })
                            props.deleteAllPage();
                            Swal.fire(result.message, "", "success")
                        } else {
                            setState({
                                ...state,
                                loading: false
                            })
                            Swal.fire(result.message, "", "error")
                        }
                    }
                )
            }
        })
    }

    return (
        <LoadingButton startIcon={<DeleteOutlineIcon/>} loading={ state.loading } className='text-transform' onClick={() => removeAllFanpage()} variant='contained' color="error">{t("dashboard.deleteAllFanpageLabel")}</LoadingButton>
    )
}